import "./abPrettyScroller.style.scss";
import { NAMES } from "./constants/abPrettyScroller.constants";

export function defineAbPrettyScrollerElement() {
  const TAG_NAME = NAMES.TAG_NAME;
  if (customElements.get(TAG_NAME)) return;

  class AbPrettyScrollerElement extends HTMLElement {

    #initialized = false;
    #track: HTMLElement;
    #isDragging = false;
    #startX = 0;
    #startScrollLeft = 0;
    #resizeObserver: ResizeObserver;

    #boundMouseMove: (e: MouseEvent) => void;
    #boundMouseUp: () => void;

    connectedCallback() {
      if (this.#initialized) return;
      this.#initialized = true;

      this.#track = document.createElement('div');
      this.#track.classList.add('ab-pretty-scroller__track');
      while (this.firstChild) this.#track.appendChild(this.firstChild);
      this.appendChild(this.#track);

      const update = () => {
        const scrollable = this.#track.scrollWidth > this.#track.clientWidth + 1;
        const atEnd = this.#track.scrollLeft + this.#track.clientWidth >= this.#track.scrollWidth - 1;
        this.classList.toggle('is-scrollable', scrollable);
        this.classList.toggle('is-scroll-end', !scrollable || atEnd);
      };

      this.#track.addEventListener('scroll', update, { passive: true });
      this.#resizeObserver = new ResizeObserver(update);
      this.#resizeObserver.observe(this.#track);
      if (this.#track.firstElementChild) {
        this.#resizeObserver.observe(this.#track.firstElementChild as HTMLElement);
      }
      

      this.#boundMouseMove = (e: MouseEvent) => {
        if (!this.#isDragging) return;
        this.#track.scrollLeft = this.#startScrollLeft - (e.pageX - this.#startX);
      };

      this.#boundMouseUp = () => {
        if (!this.#isDragging) return;
        this.#isDragging = false;
        this.#track.style.cursor = '';
      };

      this.#track.addEventListener('mousedown', (e: MouseEvent) => {
        if (this.#track.scrollWidth <= this.#track.clientWidth + 1) return;
        this.#isDragging = true;
        this.#startX = e.pageX;
        this.#startScrollLeft = this.#track.scrollLeft;
        this.#track.style.cursor = 'grabbing';
        e.preventDefault();
      });

      window.addEventListener('mousemove', this.#boundMouseMove);
      window.addEventListener('mouseup', this.#boundMouseUp);
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
      window.removeEventListener('mousemove', this.#boundMouseMove);
      window.removeEventListener('mouseup', this.#boundMouseUp);
    }

  }

  customElements.define(TAG_NAME, AbPrettyScrollerElement);
}
